import BlockHeader from "@/common/partials/block-header/block-header"
import styles from "./placeholder.module.css"
import classNames from "classnames"

export default function Placeholder({ block }) {
  return (
    <div
      className={classNames(styles.container, {
        "no-gap": block?.attrs?.blockGap === "none"
      })}>
      <BlockHeader
        icon={block?.attrs?.icon}
        heading={block?.attrs?.heading ?? block.name}
        text={block?.attrs?.text}
      />
      <Gap gap={block?.attrs?.blockGap} />
    </div>
  )
}

const Gap = ({ gap }) => {
  if (!gap) {
    return null
  }

  switch (gap) {
    case "none":
      return <p className="block-gap">Inget avstånd till nästa block</p>

    case "small":
      return <p className="block-gap">Litet avstånd till nästa block</p>

    default:
      return <p className="block-gap">Standardavstånd till nästa block</p>
  }
}
